import { handleError } from "@/utils/error";
import { useDeleteFundBasket } from "creso-core/hooks";
import { Trash2Icon } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  VisuallyHidden,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  Button,
} from "web-design-system";

export function DeleteFundBasket(props: {
  id: number;
  goal?: number;
  onDelete?: () => void;
}) {
  const { mutateAsync: deleteFundBasket } = useDeleteFundBasket(props.id);

  const [open, setOpen] = useState(false);

  const handleDeleteBasket = async () => {
    try {
      await deleteFundBasket();
      props.onDelete?.();
      toast.success("Basket deleted successfully.");
    } catch (error) {
      handleError(error, "Failed to delete fund basket");
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger
        className="hover:bg-muted w-full text-destructive flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground [&_svg]:size-4 [&_svg]:shrink-0"
        onClick={() => setOpen(true)}
      >
        <Trash2Icon className="size-4" />
        Delete Basket
      </DialogTrigger>
      <DialogContent>
        <VisuallyHidden>
          <DialogHeader>
            <DialogTitle>Delete Fund Basket</DialogTitle>
          </DialogHeader>
          <DialogDescription>Are you sure</DialogDescription>
        </VisuallyHidden>
        <span className="text-lg font-semibold">
          Are you sure you want to delete this fund basket?
        </span>
        <span className="text-sm text-muted-foreground">
          The basket will be deleted. This action cannot be undone.
        </span>
        <DialogFooter>
          <Button onClick={handleDeleteBasket} variant="outline">
            Yes, Delete
          </Button>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
